module.exports = __webpack_public_path__ + "static/media/kitchen_app_icon_new.fb322a70.svg";